import {
  Checkbox,
  Error,
  Errors,
  Field,
  Input,
  InputWrapper,
  Label,
  Radio,
  RadioGroup,
  SubmitButton,
  TextArea
} from '@smartbear/swagger-portal-component-library'
import { SchemaForm as BaseForm, FormSchema, SchemaFormProps } from 'remix-forms'

function SchemaForm<Schema extends FormSchema>(props: SchemaFormProps<Schema>) {
  return (
    <BaseForm
      className="flex flex-col space-y-6"
      fieldComponent={Field as any}
      labelComponent={Label as any}
      inputComponent={Input as any}
      multilineComponent={TextArea as any}
      radioComponent={Radio as any}
      radioGroupComponent={RadioGroup as any}
      radioWrapperComponent={InputWrapper as any}
      checkboxWrapperComponent={InputWrapper as any}
      checkboxComponent={Checkbox as any}
      buttonComponent={SubmitButton as any}
      globalErrorsComponent={Errors as any}
      errorComponent={Error as any}
      {...props}
    />
  )
}

export default SchemaForm
